import { Gantt, Willow } from "@svar-ui/react-gantt";
import "@svar-ui/react-gantt/all.css";
import "./styles.css";
import { cellWidthMap, scales } from "./consts";
import { useState } from "react";
import { Tooltip } from "./Tooltip";
import { TooltipContent } from "./TooltipContent";

const GanttChart = ({
  data,
  scale,
  columns,
  zoom,
  onSelectTask,
  start,
  end
}: {
  data: { tasks: any; links: any };
  scale: "day" | "month" | "week" | "hour";
  columns?: any;
  zoom?: boolean;
  onSelectTask?: (ev: any) => void;
  start?: any
  end?: any
}) => {
  if (!data?.tasks?.length) return <div>No data</div>;
  const [api, setApi] = useState(null);

  const init = (api: any) => {
    setApi(api);
    api.on("select-task", (ev: any) => {
      onSelectTask?.(ev)
    });
    api.intercept('drag-task', (ev: any) => {
      if (typeof ev.top !== 'undefined') return false;
      return false; // ev.width && ev.left
    });
  };

  return (
      <Willow>
        <Tooltip
          api={api}
          content={TooltipContent}
          dependencyList={data?.links}
        >
          <div
            className={
              'wx-RPSbwjNq gantt hide-delete-links hide-drag hide-progress gantt-wrapper'
            }
          >
            <Gantt
              readonly
              init={init}
              tasks={JSON.parse(JSON.stringify(data?.tasks || []))}
              links={JSON.parse(JSON.stringify(data?.links || []))}
              columns={columns || []}
              scales={scales[scale || "day"]}
              start={start}
              zoom={zoom}
              end={end}
              autoScale={false}
              taskTypes={[
                { id: 'task', label: 'Task' }, // planned task
                { id: 'summary', label: 'Summary task' }, // cat and sub cat
                // { id: 'milestone', label: 'Milestone' },
                { id: 'urgent', label: 'Urgent' }, // actual start
                // { id: 'narrow', label: 'Narrow' }, 
                // { id: 'progress', label: 'Progress' }, // sub cat
                // { id: 'round', label: 'Rounded' }, 
              ]}
              cellWidth={cellWidthMap[scale || 'day']}
              cellHeight={30}
              scaleHeight={25}
            />
            </div>
        </Tooltip>
      </Willow>
  );
};

export default GanttChart;
